import TherapistPage from 'pages/front/TherapistPage';
import TherapistIndexPage from 'pages/front/TherapistIndexPage';
import Cookie from 'pages/front/Cookie';

export default () => {
  Cookie();
  const currentPage = document.body.id;

  if (currentPage === 'therapists-show') {
    TherapistPage();
  } else if (currentPage === 'therapists-index') {
    TherapistIndexPage();
  } else if (currentPage === 'therapists-available_now') {
    import('pages/front/availableNowPage').then(({ default: availableNowPage }) => {
      availableNowPage();
    });
  }
};
